import { DataProxy } from 'apollo-cache';
import { PagesQuery } from '../../generated/graphql';
import { PhotoGalleryItemsFragment } from './../../generated/graphql';
import { pagesQuery } from '../../components/LeftContainer/graphql';
import { produce } from 'immer';

interface Args {
  pageId: number;
  cache: DataProxy;
  photoGalleryId: number;
  photoId: number;
}

function deleteGalleryPhoto({ cache, pageId, photoGalleryId, photoId }: Args) {
  const { pages } = cache.readQuery<PagesQuery>({ query: pagesQuery })!;

  const updatedPages = produce(pages, draft => {
    const page = draft.find(p => p.id === pageId);

    if (page) {
      page.items = page.items || [];
      const gallery = page.items.find(i => i.id === photoGalleryId) as PhotoGalleryItemsFragment;
      if (gallery) {
        gallery.photoItems = gallery.photoItems.filter(photo => 'id' in photo && photo?.id !== photoId);
      }
    }
  });

  cache.writeQuery({
    query: pagesQuery,
    data: { pages: updatedPages },
  });
}

export default deleteGalleryPhoto;
